{
  "uploadFile": "Importer un fichier",
  "working": "En cours",
  "thinking": "Réflexion",
  "newChat": "Nouvelle conversation",
  "recentChats": "Conversations récentes",
  "recents": "Récents",
  "chats": "Conversations",
  "chat": "Chat",
  "files": "Fichiers",
  "agents": "Agents",
  "messages_one": "{{count}} message",
  "messages_other": "{{count}} messages",
  "clickToRename": "Cliquer pour renommer",
  "deleteChat": "Supprimer la conversation",
  "archive": "Archiver",
  "unarchive": "Désarchiver",
  "archived": "Archivé",
  "welcomeTitle": "Bienvenue sur Agion Assistants",
  "welcomeSubtitle": "Démarrez une conversation avec l’assistant Agion ou sélectionnez un agent spécifique",
  "missionWelcomeTitle": "Chat de mission",
  "missionWelcomeSubtitle": "Démarrez une conversation avec l’équipe de mission. Tous les participants peuvent voir et répondre aux messages.",
  "agentWelcomeTitle": "Chat agent",
  "agentWelcomeSubtitle": "Démarrez une conversation avec cet agent. L’agent vous assistera en fonction de ses capacités et de son niveau de confiance.",
  "agionAssistants": "Agion Assistants",
  "noAgentAccess": "Aucun accès agent",
  "noAgentAccessDesc": "Vous n’avez actuellement accès à aucun agent. Veuillez contacter votre administrateur.",
  "connecting": "Connexion aux mises à jour en temps réel...",
  "reconnecting": "Reconnexion... (tentative {{attempt}})",
  "disconnected": "Mises à jour en temps réel déconnectées",
  "connectionError": "Erreur de connexion - nouvelle tentative...",
  "cancelled": "Requête annulée par l’utilisateur",
  "processingError": "Désolé, une erreur est survenue lors du traitement de votre requête. Veuillez réessayer.",
  "typeToMention": "Tapez @ pour mentionner des fichiers ou des agents...",
  "referencedFiles": "Fichiers référencés ({{count}}) :",
  "attachedFiles": "Fichiers joints ({{count}}) :",
  "all": "Tout",
  "filesCount": "Fichiers ({{count}})",
  "agentsCount": "Agents ({{count}})",
  "noFilesOrAgents": "Aucun fichier ou agent disponible",
  "uploadFilesPrompt": "Téléversez des fichiers ou attendez le chargement des agents...",
  "noFilesFound": "Aucun fichier trouvé",
  "noAgentsFound": "Aucun agent trouvé",
  "sendHint": "Appuyez sur Entrée pour envoyer, Maj+Entrée pour un saut de ligne",
  "mentionHint": "Tapez @ pour référencer des fichiers ou des agents",
  "attachHint": "Cliquez sur le trombone pour joindre des fichiers",
  "attachFile": "Joindre un fichier",
  "uploadingToStorage": "Téléversement vers le stockage...",
  "processing": "Traitement...",
  "navigateHint": "↑ ↓ pour naviguer",
  "selectHint": "↵ pour sélectionner",
  "dismissHint": "Echap pour fermer",
  "you": "Vous",
  "assistant": "Assistant",
  "generatedChart": "Graphique généré",
  "signOut": "Se déconnecter",
  "aiAgent": "Agent IA",
  "noDescription": "Aucune description disponible",
  "howCanIHelp": "Comment puis-je vous aider aujourd’hui ?",
  "addContent": "Ajouter du contenu",
  "mentionFile": "Mentionner un fichier",
  "settings": "Paramètres",
  "history": "Historique",
  "autoSelect": "Auto",
  "noResults": "Aucun résultat trouvé",
  "rename": "Renommer",
  "delete": "Supprimer",
  "copy": "Copier dans le presse-papiers",
  "copied": "Copié !",
  "regenerate": "Regénérer",
  "processedIn": "Traité en {{time}}s",
  "maxFilesReached": "Maximum {{max}} fichiers autorisés",
  "tasks": "tâches",
  "tasksCount": "{{count}} tâches",
  "searchChats": "Rechercher des conversations...",
  "noChatsFound": "Aucune conversation trouvée",
  "participants": "participants",
  "external": "externe",
  "showingAs": "Affiché comme",
  "internalNote": "Note interne",
  "internal": "Note",
  "reply": "Répondre",
  "replyToCustomer": "Répondre au client",
  "missionAccessDenied": "Vous n’avez pas accès à cette mission. Vous avez peut-être été retiré en tant que participant.",
  "missionAccessDeniedMessage": "Accès refusé. Vous n’êtes pas un participant de cette mission.",
  "voiceInput": "Saisie vocale",
  "stopRecording": "Arrêter l’enregistrement",
  "recording": "Enregistrement...",
  "transcribing": "Transcription...",
  "microphoneAccessDenied": "Accès au microphone refusé",
  "recordingFailed": "Échec de l’enregistrement",
  "disclaimer": "Les agents peuvent faire des erreurs. Vérifiez toujours les résultats.",
  "failedToGetResponse": "Impossible d’obtenir une réponse",
  "downloadChart": "Télécharger le graphique",
  "freePlan": "Plan gratuit",
  "unknownMission": "Mission inconnue",
  "unnamedMission": "Mission sans nom",
  "missions": "Missions",
  "noMissions": "Aucune mission disponible",
  "createMissionInAdmin": "Créez une mission dans le panneau d’administration",
  "newMission": "Nouvelle mission",
  "awaitingHumanInput": "En attente d’une intervention humaine",
  "open": "Ouvrir",
  "attention": "Attention",
  "running": "En cours",
  "recent": "Récent",
  "showHosts": "Afficher les hôtes",
  "hideHosts": "Masquer les hôtes",
  "timeAgo": {
    "justNow": "à l’instant",
    "minutesAgo": "il y a {{count}} min",
    "hoursAgo": "il y a {{count}} h",
    "daysAgo": "il y a {{count}} j"
  },
  "recentRuns": {
    "showAll": "Afficher toutes les conversations",
    "showMore": "Afficher plus de conversations",
    "showFewer": "Afficher moins",
    "loading": "Chargement des conversations…",
    "loadError": "Les conversations précédentes n'ont pas pu être chargées"
  },
  "missionRunning": "Mission en cours",
  "searchMissions": "Rechercher des missions...",
  "noMatchingMissions": "Aucune mission correspondante",
  "drafts": "Brouillons",
  "hostOnline": "Hôte en ligne",
  "hostOffline": "Hôte hors ligne",
  "hostStatusChecking": "Vérification du statut de l’hôte...",
  "hostStatusUnknown": "Statut de l’hôte inconnu",
  "hosts": "Hôtes",
  "noHosts": "Aucun hôte disponible",
  "unassigned": "Non affecté",
  "hostGroup": "Groupe d'hôtes",
  "selectMission": "Sélectionner une mission",
  "selectMissionDescription": "Choisissez une mission dans la barre latérale pour commencer à discuter avec votre agent.",
  "clickNewChatToStart": "Cliquez sur « Nouvelle conversation » pour commencer",
  "landing": {
    "title": "Sur quoi souhaitez-vous travailler ?",
    "subtitle": "Choisissez comment vous souhaitez commencer",
    "missionChat": "Chat de mission",
    "missionChatDescription": "Exécutez une mission et interagissez avec elle par chat",
    "knowledgeBase": "Base de connaissances",
    "knowledgeBaseDescription": "Posez des questions sur les connaissances de votre organisation",
    "chatWithData": "Chat avec les données",
    "chatWithDataDescription": "Interrogez vos sources de données connectées de manière conversationnelle",
    "selectAMission": "Sélectionnez une mission pour commencer",
    "noActiveMissions": "Aucune mission active disponible",
    "startChat": "Démarrer le chat",
    "autostart": "La mission démarrera automatiquement",
    "searchMissions": "Rechercher des missions...",
    "recentlyUpdatedMissions": "Missions récemment mises à jour",
    "missionListSubtitle": "Vos missions",
    "orStartNew": "ou démarrer une nouvelle conversation",
    "greeting": "Que souhaitez-vous faire ?",
    "inputPlaceholder": "Décrivez vos besoins ou déposez un fichier...",
    "hint": "Tapez un message ou déposez un fichier, puis sélectionnez une mission",
    "removeFile": "Supprimer le fichier",
    "loadError": "Vos missions n'ont pas pu être chargées",
    "noMissionsGuest": "Aucune mission n'a encore été partagée avec vous. Demandez à la personne qui vous a invité de vous ajouter à une mission.",
    "noMissionsGuestWithInviter": "Aucune mission n'a encore été partagée avec vous. Dès que quelqu'un en partage une, elle apparaît ici — demandez à {{inviter}} de vous ajouter à une mission.",
    "noMissionsReader": "Les missions auxquelles vous êtes ajouté apparaissent ici.",
    "guestOrgContext": "Vous êtes dans {{org}}.",
    "guestOrgContextWithInviter": "Vous êtes dans {{org}}, invité(e) par {{inviter}}.",
    "guestCapabilities": "En tant qu'invité(e), vous pouvez ouvrir et exécuter les missions qui sont partagées avec vous. Vous ne pouvez pas créer de missions ni inviter d'autres personnes.",
    "guestHintBody": "En tant qu'invité(e), vous pouvez ouvrir et exécuter les missions partagées avec vous par {{inviter}}. Les nouvelles apparaissent ici automatiquement.",
    "guestHintBodyNoInviter": "En tant qu'invité(e), vous pouvez ouvrir et exécuter les missions partagées avec vous. Les nouvelles apparaissent ici automatiquement.",
    "guestHintDismiss": "Ignorer",
    "draft": "Brouillon"
  },
  "welcome": {
    "greeting": "Comment puis-je vous aider aujourd’hui ?",
    "subtitle": "Démarrez une conversation ou choisissez une suggestion ci-dessous",
    "noMissionsSubtitle": "Pas encore de missions actives. Démarrez une conversation ou créez une mission.",
    "startConversation": "Démarrer une nouvelle conversation",
    "missionSubtitle": "Envoyez un message pour démarrer cette mission",
    "agentsInMission": "Agents :",
    "startMission": "Démarrer la mission",
    "suggestions": {
      "summarize": "Résumer les résultats récents de la mission",
      "agents": "Quels agents sont disponibles ?",
      "mission": "Aidez-moi à créer une nouvelle mission",
      "governance": "Expliquer une décision de gouvernance"
    },
    "agentSuggestions": {
      "intro": "Présentez-vous",
      "help": "En quoi pouvez-vous m’aider ?"
    }
  },
  "modes": {
    "mission": "Mission",
    "kb": "Base de connaissances",
    "data": "Données"
  },
  "conversationHistory": {
    "title": "Conversations",
    "noConversations": "Pas encore de conversations",
    "startNew": "Démarrez une nouvelle conversation ci-dessus"
  },
  "trigger": {
    "childMissionLaunched": "Une nouvelle mission a été déclenchée",
    "continueWith": "Continuer avec {{name}} ?",
    "openMission": "Ouvrir la mission",
    "missionTriggered": "Mission déclenchée"
  },
  "customer": {
    "historyLoadFailed": "La conversation n'a pas pu être chargée depuis l'hôte Edge.",
    "historyLoadFailedHint": "L'exécution a peut-être dit plus que ce qui est affiché ici. Réessayez dans un instant.",
    "historyHostUnknown": "L'hôte Edge qui a exécuté cette mission n'est pas enregistré, sa conversation est donc introuvable.",
    "progress": {
      "title": "Progression",
      "stepsCompleted": "{{completed}} sur {{total}} étapes",
      "allComplete": "Toutes les étapes terminées",
      "failed": "Échec de l’exécution"
    },
    "missionCompleted": "Mission terminée avec succès",
    "missionStopped": "Exécution arrêtée",
    "missionFailed": "Une erreur est survenue. Veuillez réessayer ou contacter le support.",
    "missionAnswerTimeout": "L'exécution s'est terminée car aucune réponse n'est arrivée à temps. Envoyez un message pour lancer une nouvelle exécution.",
    "missionToolReportedError": "L'outil n'a pas pu utiliser cette entrée : {{reason}}. Vérifiez l'entrée et réessayez.",
    "missionCriteriaNotMet": "L'exécution est terminée, mais elle n'a pas rempli tous ses critères de réussite. Vérifiez la réponse avant de vous y fier.",
    "missionNoResourceEvidence": "L'exécution n'a pu obtenir aucune donnée des systèmes connectés, la réponse peut donc être incomplète. Demandez à votre administrateur de vérifier la connexion avant de vous y fier.",
    "questionExpired": "Cette question a expiré",
    "reconnecting": "Reconnexion...",
    "streamingUnavailable": "Les mises à jour en temps réel sont temporairement indisponibles. Vous pouvez toujours parcourir votre historique de conversation.",
    "typeMessage": "Tapez un message...",
    "typeToRestart": "Tapez un message pour démarrer une nouvelle exécution...",
    "newRunDivider": "Nouvelle exécution lancée. Les messages précédents sont affichés pour référence.",
    "respondToQuestion": "Tapez votre réponse...",
    "waitingForMission": "En attente de la réponse de la mission...",
    "stop": "Arrêter",
    "stopMission": "Arrêter la mission",
    "pause": "Mettre en pause",
    "pauseMission": "Mettre la mission en pause",
    "resume": "Reprendre",
    "resumeMission": "Reprendre la mission",
    "historyHostOfflineNamed": "{{name}}, l'hôte Edge qui contient cette conversation, est hors ligne. Réessayez lorsqu'il sera de retour.",
    "historyHostOffline": "L'hôte Edge qui contient cette conversation est hors ligne. Réessayez lorsqu'il sera de retour.",
    "runHostMoved": "Cette exécution a démarré sur un autre hôte Edge, car celui qui contient la conversation précédente n'est pas disponible. Les fichiers des messages précédents ne sont pas disponibles pour cette exécution.",
    "conversationOwnedByOther": "Cette conversation appartient à une autre personne. Elle seule peut la lire ici.",
    "conversationStartedAutomatically": "Cette conversation a été lancée par une planification ou un déclencheur, pas par une personne. Son contenu ne s'ouvre que depuis la page d'audit."
  },
  "kb": {
    "title": "Base de connaissances",
    "placeholder": "Posez une question...",
    "thinking": "Recherche dans la base de connaissances...",
    "noSources": "Aucune source trouvée",
    "sources": "Sources",
    "fromOrg": "Organisation",
    "fromMission": "Mission",
    "askFollowUp": "Posez une question de suivi..."
  },
  "data": {
    "title": "Chat avec les données",
    "selectResources": "Sélectionner les sources de données",
    "selectSources": "Sélectionnez les sources de données à interroger",
    "noResources": "Aucune source de données disponible",
    "noSources": "Aucune source de données disponible",
    "sourcesSelected": "sources sélectionnées",
    "askPrompt": "Posez une question sur vos sources de données",
    "selected": "sélectionnées",
    "startChat": "Démarrer le chat",
    "placeholder": "Posez une question sur vos données...",
    "querying": "Interrogation des sources de données..."
  },
  "governance": {
    "prefix": "Gouvernance",
    "allowed": "Gouvernance : Autorisé",
    "denied": "Refusé",
    "obfuscated": "Masqué",
    "escalated": "Escaladé"
  },
  "trust": {
    "tooltip": {
      "tier0": "Restreint — Cet agent fonctionne sous supervision maximale. Toutes les actions nécessitent une approbation.",
      "tier1": "Limité — Cet agent peut effectuer des tâches de base mais s’arrête aux décisions importantes.",
      "tier2": "Standard — Cet agent gère le travail courant et s’arrête aux décisions clés.",
      "tier3": "Élevé — Cet agent dispose de permissions étendues et agit avec un minimum d’interruptions."
    }
  },
  "executionLog": {
    "title": "Activité",
    "openPanel": "Ouvrir l’activité",
    "closePanel": "Fermer l’activité",
    "waitingForEvents": "En attente d’événements...",
    "noEventsYet": "Pas encore d’événements",
    "contentOnHost": "Contenu stocké sur l'hôte Edge",
    "mission": "Mission",
    "rankingDegraded": "Classement dégradé",
    "noConfidentMatch": "Aucune correspondance fiable",
    "warningCount": "{{count}} avertissement",
    "warningCount_other": "{{count}} avertissements",
    "forced": {
      "label": "Terminé prématurément",
      "budget": "Terminé prématurément : plus aucun tour disponible. Le résultat peut être incomplet. Réduisez ce que l’étape demande, ou divisez-la.",
      "stuckRepeating": "Terminé prématurément : le même appel a été répété. Le résultat peut être incomplet. Modifiez les instructions de l’étape.",
      "repeatedFailure": "Terminé prématurément après des erreurs d’outil répétées. Le résultat peut être incomplet. Vérifiez la connexion utilisée par l’étape.",
      "schemaChurn": "Terminé prématurément : la structure des données source changeait sans cesse. Le résultat peut être incomplet. Vérifiez le schéma de la source."
    }
  },
  "missionChat": {
    "editInDesigner": "Modifier dans le concepteur"
  },
  "workflow": {
    "status": "Flux de travail : {{status}}",
    "pause": "Pause",
    "resume": "Reprendre",
    "cancel": "Annuler",
    "approve": "Approuver",
    "reject": "Rejeter",
    "progress": "{{completed}} sur {{total}} étapes terminées",
    "currentStep": "Exécution : {{step}}{{agent}}",
    "turn": "Tour {{current}}/{{max}}",
    "turnProgress": "Tour {{current}} sur {{max}}",
    "duration": "Durée : {{duration}}",
    "waitingApproval": "{{count}} étape(s) en attente d’approbation",
    "noSteps": "Aucune étape de flux de travail définie",
    "dependsOn": "Dépend de",
    "viewDetails": "Voir les détails du flux de travail",
    "event": {
      "started": "Flux de travail démarré",
      "startedDescription": "Exécution de {{steps}} étapes",
      "paused": "Flux de travail en pause",
      "pausedDescription": "Le flux de travail a été mis en pause",
      "resumed": "Flux de travail repris",
      "resumedDescription": "L’exécution du flux de travail a repris",
      "completed": "Flux de travail terminé",
      "completedDescription": "{{steps}} étapes terminées en {{duration}}",
      "failed": "Flux de travail échoué",
      "cancelled": "Flux de travail annulé",
      "cancelledDescription": "L’exécution du flux de travail a été annulée",
      "stepStarted": "Étape démarrée : {{step}}",
      "stepStartedAgent": "L’agent {{agent}} est en cours d’exécution",
      "stepStartedDescription": "L’exécution de l’étape a démarré",
      "stepProgress": "Progression de l’étape : {{step}}",
      "stepProgressDescription": "Tour {{current}} sur {{max}}",
      "stepCompleted": "Étape terminée : {{step}}",
      "stepCompletedDescription": "Terminée en {{duration}}",
      "stepFailed": "Étape échouée : {{step}}",
      "stepWaitingApproval": "Approbation requise : {{step}}",
      "unknown": "Événement de flux de travail"
    },
    "command": {
      "statusHelp": "Afficher le statut du flux de travail",
      "pauseHelp": "Mettre en pause le flux de travail en cours",
      "resumeHelp": "Reprendre le flux de travail en pause",
      "cancelHelp": "Annuler le flux de travail en cours",
      "approveHelp": "Approuver l’étape en attente",
      "rejectHelp": "Rejeter l’étape en attente"
    }
  },
  "outputFile": {
    "download": "Télécharger",
    "downloading": "Téléchargement…",
    "downloadFailed": "Échec du téléchargement. Veuillez réessayer.",
    "noHost": "Les fichiers de cet assistant ne peuvent pas encore être téléchargés ici.",
    "noLongerAvailable": "Ce fichier n’est plus disponible. Demandez à l’assistant de le créer à nouveau.",
    "noAccess": "Vous n’avez pas accès à ce fichier.",
    "hostOffline": "L’hôte qui contient ce fichier est hors ligne. Réessayez lorsqu’il sera connecté."
  },
  "delivery": {
    "waiting": "En attente de la fin du téléversement des fichiers…",
    "sending": "Envoi…",
    "queued": "En file d’attente : l’assistant le lira après son étape en cours.",
    "delivered": "Remis",
    "notConnected": "Non envoyé : la connexion à l’assistant est interrompue.",
    "noReceipt": "Non confirmé : aucun accusé de réception n’est arrivé, l’assistant ne l’a peut-être pas reçu.",
    "notStarted": "Non envoyé : la conversation n’a pas pu démarrer.",
    "notAccepted": "L’hôte n’a pas confirmé le message. Réessayez. Si l’échec persiste, l’hôte est peut-être hors ligne ou doit être mis à jour.",
    "undelivered": "Non remis : l’exécution s’est terminée avant que l’assistant ne le lise.",
    "unconfirmed": "Remise non confirmée : l’hôte n’a pas pu confirmer avoir reçu cette réponse.",
    "refused": "Non remis.",
    "backInComposer": "Le message est de retour dans la zone de saisie pour être renvoyé.",
    "chooseAgain": "Choisissez à nouveau votre réponse."
  },
  "receiptReason": {
    "invalidMessage": "Le message n’a pas pu être lu.",
    "notSubscribed": "Cette conversation ne suit plus l’exécution. Rechargez la page et réessayez.",
    "senderNotAllowed": "Seule la personne qui a lancé cette exécution peut lui envoyer des messages.",
    "runNotLive": "L’exécution n’est plus en cours.",
    "hostNotConnected": "L’hôte qui exécute l’assistant n’est pas connecté.",
    "runnerNotConnected": "L’hôte qui exécute l’assistant est connecté, mais pas son moteur d’exécution.",
    "messageTooLarge": "Le message est trop volumineux pour être envoyé.",
    "channelFull": "La connexion à l’assistant est saturée. Réessayez dans un instant.",
    "inboxFull": "L’assistant a déjà plusieurs messages en attente. Envoyez celui-ci après qu’il les aura lus.",
    "modeDoesNotAccept": "Cette exécution n’accepte pas de messages pendant qu’elle travaille.",
    "duplicate": "L’assistant a déjà ce message.",
    "unknownMessageType": "Le serveur n’a pas reconnu le message ; il doit peut-être être mis à jour.",
    "runEndedBeforeDelivery": "L’exécution s’est terminée avant que l’assistant ne le lise.",
    "attachmentInvalid": "Les fichiers joints n'ont pas pu être vérifiés. Supprimez-les et joignez-les à nouveau.",
    "attachmentHostMismatch": "Ces fichiers ont été envoyés sur un autre serveur. Joignez-les sur le serveur de cette exécution.",
    "attachmentHostAmbiguous": "Le serveur contenant ces fichiers n'a pas pu être vérifié. Joignez à nouveau les fichiers.",
    "attachmentTooMany": "Ce message contient trop de fichiers. Supprimez-en quelques-uns et réessayez.",
    "attachmentUnavailable": "Les fichiers joints sont indisponibles. Réessayez ou retirez-les puis joignez-les à nouveau."
  },
  "questionAnswerReason": {
    "answerInProgress": "Une autre réponse à cette question est encore en cours de vérification. Patientez un instant et réessayez.",
    "answerAdmissionUnavailable": "L’hôte n’a pas pu prendre en compte la réponse à temps. Réessayez.",
    "invalidAnswer": "La réponse n’a pas pu être lue. Vérifiez-la et réessayez.",
    "attemptConflict": "Cette réponse diffère de l’envoi précédent qu’elle répète. Envoyez-la à nouveau.",
    "questionClosed": "Cette question n’est plus ouverte.",
    "confirmationUnavailable": "L’hôte ne peut plus confirmer s’il a reçu cette réponse.",
    "senderNotAllowed": "Vous n’êtes pas autorisé à répondre à cette question.",
    "runNotLive": "L’exécution n’est plus en cours.",
    "attachmentInvalid": "Les fichiers joints n'ont pas pu être vérifiés. Supprimez-les et joignez-les à nouveau.",
    "attachmentHostMismatch": "Ces fichiers ont été envoyés sur un autre serveur. Joignez-les sur le serveur de cette exécution.",
    "attachmentHostAmbiguous": "Le serveur contenant ces fichiers n'a pas pu être vérifié. Joignez à nouveau les fichiers.",
    "attachmentTooMany": "Cette réponse contient trop de fichiers. Supprimez-en quelques-uns et réessayez.",
    "attachmentUnavailable": "Les fichiers joints sont indisponibles. Réessayez ou retirez-les puis joignez-les à nouveau."
  },
  "questionClosed": {
    "cancelled": "Cette question a été retirée.",
    "expired": "Cette question a expiré.",
    "publicationFailed": "Cette question n’a pas pu être affichée ; elle a donc été fermée.",
    "executionEnded": "Cette question a été fermée à la fin de l’exécution."
  },
  "composer": {
    "agentWorking": "L’assistant travaille. Vous pourrez répondre lorsqu’il vous posera une question.",
    "chooseAnOption": "Répondez en choisissant l’une des réponses ci-dessus.",
    "questionClosed": "Cette question n’est plus ouverte.",
    "attachUnavailable": "Cet assistant ne peut pas recevoir de fichiers.",
    "attachFindingHost": "Recherche du serveur qui recevra vos fichiers…",
    "attachGroupOffline": "Aucun des serveurs sur lesquels fonctionne cet assistant n’est en ligne : il ne peut pas recevoir de fichiers pour le moment. Réessayez lorsqu’un serveur sera de retour.",
    "attachHostNotFound": "Le serveur qui recevrait vos fichiers est introuvable. Rechargez la page pour réessayer.",
    "fileNotUploaded": "Un fichier n’a pas été téléversé. Réessayez ou retirez-le, puis envoyez.",
    "launchFailed": "La conversation n’a pas pu démarrer.",
    "tooLong": "Ce message est trop long pour être envoyé. Veuillez le raccourcir.",
    "pasteTooLong": "Ce collage rendrait le message trop long à envoyer ; il n’a donc pas été ajouté.",
    "notReadyTool": "Cet assistant ne peut pas encore démarrer, car un outil qu’il utilise n’est pas prêt. Demandez à son propriétaire de le terminer.",
    "notReadySetup": "Cet assistant ne peut pas encore démarrer, car sa configuration n’est pas terminée. Demandez à son propriétaire de la terminer."
  },
  "launchRefusal": {
    "defaultModelMissing": {
      "admin": "Votre organisation n’a pas de modèle de chat par défaut ; cette mission n’a donc aucun agent sous lequel s’exécuter. Choisissez-en un dans la console d’administration, sous Gouvernance > Ressources > Modèles.",
      "member": "Votre organisation n’a pas de modèle de chat par défaut ; cette mission n’a donc aucun agent sous lequel s’exécuter. Demandez à un administrateur d’en choisir un."
    },
    "openModelSettings": "Ouvrir les paramètres des modèles",
    "grantAccessNotReady": {
      "named": "L’exécution n’a pas démarré, car l’accès de l’agent de cette mission aux ressources suivantes n’est pas encore prêt : {{resources}}. Réessayez dans un instant. Si le problème persiste, contactez support@agion.ai.",
      "unnamed": "L’exécution n’a pas démarré, car l’accès de l’agent de cette mission n’est pas encore prêt. Réessayez dans un instant. Si le problème persiste, contactez support@agion.ai."
    },
    "grantAdminDenied": {
      "named": "L’exécution n’a pas démarré, car un administrateur a retiré l’accès de cet agent aux ressources suivantes : {{resources}}. Adressez-vous à votre administrateur ou contactez support@agion.ai.",
      "unnamed": "L’exécution n’a pas démarré, car un administrateur a retiré l’accès de cet agent à une ressource utilisée par cette mission. Adressez-vous à votre administrateur ou contactez support@agion.ai."
    },
    "grantTrustTierTooLow": {
      "named": "L’exécution n’a pas démarré, car le niveau de confiance de cet agent ne permet pas ce dont cette mission a besoin sur les ressources suivantes : {{resources}}. Adressez-vous à votre administrateur ou contactez support@agion.ai.",
      "unnamed": "L’exécution n’a pas démarré, car le niveau de confiance de cet agent ne permet pas ce dont cette mission a besoin sur une ressource qu’elle utilise. Adressez-vous à votre administrateur ou contactez support@agion.ai."
    }
  },
  "escalations": {
    "title": "Escalades",
    "fallbackTitle": "Escalade",
    "approve": "Approuver",
    "deny": "Refuser",
    "reasonPlaceholder": "Motif (facultatif)",
    "confirmApprove": "Confirmer l'approbation",
    "confirmDeny": "Confirmer le refus",
    "cancel": "Annuler",
    "resolving": "Envoi…",
    "expired": "Expirée",
    "expiredNote": "Plus actionnable — l'étape a expiré avant une décision.",
    "missionLabel": "Mission",
    "actionLabel": "Veut exécuter",
    "ruleLabel": "Règle",
    "traceToggle": "Détails de la politique",
    "consequence": "Approuver exécute cette étape maintenant · Refuser la bloque",
    "type": {
      "actionApproval": "Approbation requise",
      "chatHandoff": "Transfert demandé",
      "contentReview": "Révision du contenu",
      "guidance": "Conseil demandé",
      "complianceReview": "Revue de conformité",
      "question": "Question"
    },
    "question": {
      "answerPlaceholder": "Votre réponse",
      "submit": "Envoyer la réponse",
      "answerLabel": "Réponse",
      "answeredByLabel": "Répondu par",
      "answeredAtLabel": "Répondu le",
      "answerKeptWithRun": "La réponse est conservée avec l'exécution.",
      "unavailable": "Cette question ne peut pas être affichée.",
      "error": {
        "invalid": "La question n'accepte pas cette réponse.",
        "expired": "La question a expiré avant l'arrivée de la réponse.",
        "alreadyAnswered": "Quelqu'un d'autre a répondu à la question en premier.",
        "forbidden": "Vous ne pouvez pas répondre à cette question.",
        "failed": "La réponse n'a pas été envoyée. Réessayez.",
        "ticketMismatch": "La réponse ne correspondait pas à votre session. Rechargez la page et réessayez.",
        "ticketExpired": "L'envoi de la réponse a pris trop de temps. Réessayez.",
        "runNotLive": "L'exécution est terminée, elle ne peut donc pas recevoir la réponse.",
        "hostNotConnected": "L'hôte qui exécute cette mission n'est pas connecté. Réessayez plus tard.",
        "malformed": "La réponse n'a pas pu être lue. Réessayez.",
        "unreachable": "Impossible de joindre l'exécution. Réessayez.",
        "unconfirmed": "L'exécution a la réponse, mais elle n'est pas encore enregistrée. Vérifiez à nouveau dans un instant."
      },
      "form": {
        "required": "Obligatoire",
        "submitNone": "Je n'ai pu déterminer aucun de ces champs",
        "answeredFields": "Champs renseignés",
        "noneAnswered": "Aucun champ n'a pu être déterminé.",
        "error": {
          "number": "Saisissez un nombre.",
          "date": "Saisissez une date complète."
        }
      }
    },
    "evidence": {
      "open": "Ouvrir le justificatif",
      "hide": "Masquer le justificatif",
      "opening": "Ouverture…",
      "label": "Justificatif",
      "task": "Tâche",
      "context": "Contexte",
      "constraints": "Contraintes",
      "error": {
        "unavailable": "Le justificatif ne peut pas être ouvert.",
        "tooLarge": "Le justificatif est trop volumineux pour être ouvert ici.",
        "failed": "Le justificatif ne s'est pas ouvert. Réessayez."
      }
    },
    "questionCard": {
      "waiting": "Une question attend une personne qui peut la trancher.",
      "answered": "Répondu",
      "askedBy": "Posée par",
      "evidenceTitle": "Ce que le spécialiste a vu",
      "evidenceUnavailable": "Le justificatif ne peut pas être affiché ici.",
      "evidenceEmpty": "Le spécialiste n'a reçu aucun détail."
    },
    "header": {
      "questionWaiting": "Une question attend",
      "unknownMission": "Une mission",
      "answerInEscalations": "Répondre dans Escalades"
    },
    "reviewReason": {
      "decisionCouldNotChoose": "Le modèle de décision n'a pas pu choisir.",
      "decisionUnavailable": "Le modèle de décision n'était pas disponible.",
      "agentUnsure": "Le modèle du spécialiste n'était pas sûr.",
      "agentUnavailable": "Le modèle du spécialiste n'était pas disponible.",
      "agentModelSkipped": "La mission demande directement à une personne lorsque le modèle de décision ne peut pas choisir."
    }
  },
  "operatorTakeover": {
    "personMarker": "Personne",
    "takeOver": "Prendre le relais",
    "takingOver": "Prise de relais…",
    "heldByYou": "Vous tenez cette conversation.",
    "openConversation": "Ouvrir la conversation",
    "banner": "Vous répondez au client en votre propre nom",
    "holdUntil": "Vous tenez cette conversation jusqu’à {{time}}.",
    "ended": "Vous ne tenez plus cette conversation.",
    "notHeld": "Vous ne tenez pas cette conversation.",
    "earlierRunsIncomplete": "Une partie de la conversation précédente n'a pas pu être chargée.",
    "placeholder": "Écrire au client",
    "send": "Envoyer",
    "handBack": "Rendre la main",
    "handingBack": "Remise en cours…",
    "handBackFailed": "La conversation n’a pas été rendue. Réessayez.",
    "reply": {
      "sending": "Envoi…",
      "accepted": "Remis au client",
      "notSent": "Non envoyé : la connexion est interrompue.",
      "refused": "Refusé"
    },
    "refusal": {
      "expired": "La demande a expiré avant que vous ne preniez le relais.",
      "self": "Vous avez démarré cette conversation, quelqu’un d’autre doit donc prendre le relais.",
      "notPending": "Quelqu’un d’autre a pris le relais, ou la conversation est terminée.",
      "forbidden": "Vous ne pouvez pas prendre le relais de cette conversation.",
      "failed": "Le relais n’a pas été pris. Réessayez."
    },
    "replyRefusal": {
      "malformed": "La réponse n’a pas pu être lue. Vérifiez le texte et renvoyez-le.",
      "senderNotAllowed": "Reconnectez-vous pour répondre.",
      "notSubscribed": "Cette conversation n’est pas ouverte ici. Rechargez-la et répondez à nouveau.",
      "disabled": "La prise de relais des conversations est désactivée.",
      "noHold": "Vous ne tenez plus cette conversation.",
      "notOperator": "Une autre personne tient cette conversation.",
      "unavailable": "La conversation n’a pas pu être jointe. Réessayez.",
      "other": "La réponse a été refusée."
    }
  },
  "notifications": {
    "hitlTitle": "La mission attend votre réponse",
    "governanceTitle": "Alerte de gouvernance",
    "escalationTitle": "Escalade en attente de décision"
  },
  "delegation": {
    "blocked": {
      "label": "Bloqué par la configuration",
      "message": "{{agent}} n’a pas pu terminer : {{reason}}.",
      "targetNotBound": "le système n’est pas connecté à cette mission",
      "targetNotAuthorized": "cette mission n’est pas autorisée à utiliser le système",
      "operationOutsideScope": "l’opération n’est pas autorisée dans cette mission",
      "credentialUnavailable": "la connexion n’a pas d’identifiants utilisables",
      "other": "la configuration de la mission n’autorise pas cette demande",
      "hint": "L’auteur de la mission ou un administrateur peut modifier cela."
    }
  },
  "launchInputs": {
    "title": "Valeurs de départ",
    "hint": "L’exécution démarre avec ces valeurs.",
    "enterValue": "Saisissez une valeur pour démarrer l’exécution.",
    "invalidJson": "Saisissez un JSON valide, par exemple {\"key\": \"value\"} ou [1, 2].",
    "invalidNumber": "Saisissez un nombre.",
    "invalidInteger": "Saisissez un nombre entier.",
    "invalidBoolean": "Saisissez true ou false.",
    "selectFile": "Sélectionner un fichier téléversé",
    "uploadFile": "Téléverser un fichier",
    "uploadingFile": "Téléversement du fichier…",
    "uploadFailed": "Le téléversement du fichier a échoué.",
    "retryUpload": "Réessayer le téléversement",
    "removeFile": "Retirer le fichier",
    "completeFile": "Sélectionnez un fichier dont le téléversement est terminé.",
    "nextMessageStartsRun": "Votre prochain message lance une nouvelle exécution.",
    "changeValues": "Modifier les valeurs de départ",
    "hideValues": "Masquer les valeurs de départ"
  },
  "nextSections": {
    "attention": {
      "title": "En attente de votre réponse",
      "awaitingInput": "En attente de votre saisie",
      "policyDecision": "Décision de politique",
      "escalate": "Escalader"
    },
    "recent": {
      "loadError": "Les conversations récentes n'ont pas pu être chargées",
      "nameNotLoaded": "Nom de la mission non chargé",
      "outcome": {
        "running": "En cours",
        "completed": "Terminée",
        "failed": "Échec",
        "cancelled": "Arrêtée"
      }
    }
  },
  "nextConversation": {
    "agent": "Agent",
    "copy": "Copier",
    "helpful": "Utile",
    "notHelpful": "Pas utile",
    "attach": "Joindre des fichiers",
    "voice": "Saisie vocale",
    "send": "Envoyer le message",
    "hint": "Entrée pour envoyer · Maj+Entrée pour une nouvelle ligne",
    "working": "La mission est en cours",
    "governance": {
      "deny": "Refusé",
      "obfuscate": "Masqué",
      "escalate": "Transmis",
      "audit": "Journalisé"
    },
    "historyLoadError": "Cette conversation n'a pas pu être chargée depuis l'hôte Edge",
    "question": {
      "closed": "Cette question n'est plus ouverte.",
      "submit": "Envoyer la réponse",
      "atLeast_one": "Choisissez au moins {{count}} option.",
      "atLeast_other": "Choisissez au moins {{count}} options.",
      "otherLabel": "Autre",
      "otherPlaceholder": "Saisissez votre réponse"
    },
    "escalation": {
      "approve": "Approuver",
      "deny": "Refuser",
      "approveConsequence": "Si vous approuvez, {{agent}} poursuit son exécution et effectue l'action demandée.",
      "denyConsequence": "Si vous refusez, {{agent}} n'effectue pas l'action, et l'étape de l'exécution qui l'a demandée échoue.",
      "reasonLabel": "Motif",
      "reasonPlaceholder": "Motif...",
      "reasonRequired": "Un motif est requis.",
      "confirmApprove": "Confirmer l'approbation",
      "confirmDeny": "Confirmer le refus",
      "cancel": "Annuler",
      "backToRequest": "Retour"
    }
  },
  "nextActivity": {
    "turn": "Tour",
    "thinking": "Réflexion",
    "started": "Démarré",
    "completed": "Terminé",
    "failed": "Échoué",
    "succeeded": "Réussi",
    "waiting": "en attente...",
    "humanInput": "Saisie humaine",
    "humanResponse": "Réponse humaine",
    "orchestrator": "Orchestrateur",
    "delegatedTo": "Délégué à",
    "error": "Erreur",
    "terminalFailure": "Échec terminal",
    "thinkingRedactedBody": "Le raisonnement interne du modèle a été masqué.",
    "model": "Modèle",
    "tokens": "Tokens",
    "duration": "Durée",
    "depth": "Profondeur",
    "in": "entrée",
    "out": "sortie",
    "filterAll": "Tout",
    "filterTurns": "Tours",
    "filterTools": "Outils",
    "filterHitl": "HITL",
    "expand": "Afficher plus",
    "collapse": "Afficher moins",
    "statusRunning": "Exécution de la mission",
    "statusComplete": "Exécution terminée",
    "statusPaused": "En pause",
    "statusFailed": "Échec de l'exécution",
    "steps": "Étapes",
    "costLive": "Coût à ce stade",
    "costEstimate": "Coût estimé",
    "costUnknown": "Inconnu",
    "usageNotReported_one": "{{count}} appel, utilisation non signalée",
    "usageNotReported_other": "{{count}} appels, utilisation non signalée",
    "costExcludesUnreported_one": "Hors {{count}} appel sans utilisation signalée",
    "costExcludesUnreported_other": "Hors {{count}} appels sans utilisation signalée",
    "checkingModelUse": "Vérification de l'utilisation du modèle…",
    "tokenSpend": "Consommation de jetons",
    "awaitingFirstCall": "En attente du premier appel au modèle",
    "executionLog": "Journal d'exécution",
    "jumpToLatest": "Aller au plus récent",
    "showBreakdown": "Afficher le détail par modèle",
    "hideBreakdown": "Masquer le détail par modèle",
    "unnamedStep": "Étape sans nom",
    "runEnding": {
      "tool_result_too_large": "Un outil a renvoyé trop de données",
      "host_disconnected": "L'hôte a perdu sa connexion",
      "idle_timeout": "L'exécution ne répond plus",
      "context_window_exhausted": "La conversation est devenue trop longue pour le modèle",
      "llm_deadline": "Le modèle n'a pas répondu à temps",
      "mission_budget_exceeded": "L'exécution a épuisé son budget",
      "provider_unavailable": "Le fournisseur du modèle était saturé ou indisponible",
      "provider_quota_exhausted": "Le quota du fournisseur du modèle est épuisé",
      "model_tool_format_rejected": "Le modèle n'a pas pu utiliser les outils de la mission",
      "repeated_gate_rejection": "L'exécution a échoué plusieurs fois au même contrôle de fin",
      "criteria_not_met": "La réponse ne remplit pas tous les critères de réussite",
      "no_successful_resource_evidence": "Aucune donnée n'est venue des systèmes connectés",
      "timeout": "Un appel a pris trop de temps",
      "permission_denied": "L'accès a été refusé",
      "not_found": "Un élément est introuvable",
      "rate_limited": "Trop de requêtes",
      "network_error": "Un système était injoignable",
      "service_unavailable": "Un système était indisponible",
      "validation_error": "Une requête a été rejetée comme invalide",
      "token_limit": "La limite de longueur du modèle a été atteinte",
      "internal_error": "Une erreur inattendue",
      "schema_error": "Une réponse avait une forme inattendue",
      "model_output_unfit": "Le modèle a donné à plusieurs reprises des réponses impossibles à afficher",
      "transport_error": "Les messages de l'exécution n'ont pas pu être transmis",
      "tool_blocked": "Agion a bloqué l'appel"
    },
    "statusStarting": "Démarrage",
    "statusDone": "Terminé",
    "waitingForAnswer": "En attente de votre réponse",
    "noModelUse": "Aucune utilisation de modèle enregistrée pour cette exécution",
    "questionStep": "Question",
    "messageToYou": "Message pour vous",
    "answerStep": "Réponse",
    "agentStep": "Agent",
    "runStep": "Exécution",
    "stepId": "Identifiant de l'étape",
    "filterQuestions": "Questions"
  },
  "header": {
    "search": "Rechercher des messages",
    "closeSearch": "Fermer la recherche",
    "metaStarted": "Démarré {{time}}",
    "metaTrust": "Confiance : {{tier}}",
    "metaRuns": "{{count}} exécutions",
    "allRuns": "Toutes les exécutions",
    "moreActions": "Plus d'actions"
  },
  "nextRunStep": {
    "running": "En cours",
    "waiting": "À l'arrêt",
    "completed": "Terminée",
    "warning": "Terminée avec un avertissement",
    "failed": "Échec",
    "moreTools_one": "+{{count}} autre",
    "moreTools_other": "+{{count}} autres",
    "unnamedStep": "Étape sans nom"
  },
  "runEnd": {
    "endedWithCause": "L'exécution s'est terminée : {{cause}}.",
    "missing": "Il manque : {{items}}.",
    "failed": "L'exécution a échoué.",
    "cause": {
      "agent": "l'agent n'a pas pu terminer le travail",
      "person": "elle attendait une personne",
      "environment": "un système connecté ou un service n'a pas fonctionné comme prévu",
      "platform": "la plateforme a rencontré un problème",
      "missionDesign": "les paramètres ou les limites de la mission l'ont arrêtée",
      "unknown": "la raison n'a pas été enregistrée",
      "noAnswer": "personne n'a répondu à temps"
    },
    "next": {
      "agent": "Précisez la tâche, puis relancez-la.",
      "person": "Relancez la mission quand quelqu'un peut répondre.",
      "environment": "Vérifiez le système connecté ou le service, puis relancez la mission.",
      "missionDesign": "Vérifiez les paramètres et les limites de la mission, puis relancez-la.",
      "platform": "Relancez la mission. Si cela se reproduit, contactez votre administrateur.",
      "unknown": "Relancez la mission. Si cela se reproduit, contactez votre administrateur.",
      "noAnswer": "Relancez la mission quand quelqu'un peut répondre."
    },
    "missingItem": {
      "criteria": "tous les critères de réussite remplis",
      "resourceData": "des données des systèmes connectés",
      "personAnswer": "une réponse d'une personne",
      "stepOutputs": "les résultats de chaque étape",
      "time": "du temps pour terminer",
      "room": "de la place pour que le modèle lise tout"
    },
    "cutNote": {
      "title": "Certaines valeurs de cette exécution ont été raccourcies pour respecter ses limites.",
      "kind": {
        "delegationHandoff": "Des résultats transmis d'un agent à un autre ont été raccourcis ou omis.",
        "taskPromptValue": "Certains résultats antérieurs ont été raccourcis pour tenir dans le modèle.",
        "contextShortened": "Des messages antérieurs de la conversation ont été raccourcis pour tenir dans le modèle.",
        "runStateText": "Des résultats d'objectifs antérieurs et des réponses recueillies ont été raccourcis.",
        "verdictEvidence": "Les éléments cités dans la vérification de la réponse ont été raccourcis.",
        "hydratedRows": "Une étape n'a reçu que les premières lignes d'un grand tableau.",
        "schemaTables": "Certaines tables ou certains jeux de données d'un système connecté n'ont pas été montrés au modèle.",
        "runLimitBounded": "Une limite définie dans la mission dépassait son maximum ; l'exécution a donc utilisé le maximum."
      },
      "storage": "Activer le stockage de l'espace de travail sur l'hôte conserve les valeurs entières."
    },
    "code": {
      "CONTEXT_LIMIT": {
        "title": "Le texte envoyé au modèle était trop long, même après raccourcissement",
        "next": "Raccourcissez l'entrée ou découpez la tâche en parties plus petites, puis relancez-la."
      },
      "RUN_TIME_LIMIT": {
        "title": "La limite de durée a été atteinte",
        "next": "Un administrateur de l'organisation peut augmenter la limite de durée d'exécution dans Paramètres, dans la plage autorisée par Agion, ou la tâche peut être réduite pour qu'elle se termine plus tôt."
      },
      "SOURCE_READ_INCOMPLETE": {
        "title": "Un système connecté a cessé d'envoyer des données avant la fin de la lecture",
        "next": "Vérifiez le système connecté, puis relancez la mission."
      },
      "PROVIDER_QUOTA_EXHAUSTED": {
        "next": "Un administrateur de l'organisation peut augmenter le quota auprès du fournisseur du modèle ou choisir un autre modèle."
      }
    },
    "codeLabel": "Code : {{code}}",
    "reason": {
      "hostStoreFull": {
        "title": "Le stockage des résultats de l'hôte était plein avec les données d'exécutions encore en cours",
        "next": "Un propriétaire ou un administrateur de l'organisation peut vérifier la limite de taille des résultats enregistrés sur la page de l'hôte, puis relancer la mission."
      }
    }
  }
}
